export function resolveRunNowUnavailableReason(
  source,
  { canManageSources = true, isBusy = false, isRunning = false } = {}
) {
  if (!canManageSources) {
    return "Requires source manage permission.";
  }
  if (isBusy) {
    return "Another action is already in progress for this data source.";
  }
  if (isRunning) {
    return "This data source is already running.";
  }
  if (source?.enabled === false) {
    return "Enable this data source before running.";
  }
  if (source?.disabledRunNowReason) {
    return source.disabledRunNowReason;
  }
  if (source?.supportsRunNow === false) {
    return source.collectorWarning || "Manual runs are not supported for this data source.";
  }
  if (source?.collectorImplemented === false) {
    return source.collectorWarning || "No collector is implemented for this data source yet.";
  }
  return null;
}

export function resolveScheduleUnavailableReason(
  source,
  { canManageSources = true, isBusy = false } = {}
) {
  if (!canManageSources) {
    return "Requires source manage permission.";
  }
  if (isBusy) {
    return "Another action is already in progress for this data source.";
  }
  if (source?.disabledScheduleReason) {
    return source.disabledScheduleReason;
  }
  if (source?.supportsSchedule === false) {
    return "Scheduling is not supported for this data source.";
  }
  return null;
}
